import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isCaseSaved } from "../../redux/actions/liabilty";
import { clearStoredGlobalState } from "../../utils/helper";
import { caseLimitReachedHtml } from "../../utils/constant";
import Constants from "../../Constants";
import { toaster } from "../../utils/toast";
import { confirm } from "../../utils/swal";
import useAxios from "../../hooks/useAxios";
import XButton from "../common/XButton";

const AddCaseButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getData,isLoading } = useAxios();
    const { subscription } = useSelector((state) => state.users || {});
    const { rollOverCredits = 0, remainingDemand = 0 } = subscription || {};

    const createCaseAndNavigate = async () => {
        try {
            clearStoredGlobalState(dispatch);
            const response = await getData(Constants.ApiUrl.case.addCase);

            if (!response?.success) {
                toaster({ message: response.message, success: false });
                return;
            }

            navigate(`/case/edit/${response.caseId}`, { replace: true });
        } catch (error) {
            console.error("Case creation failed:", error);
        }
    };

    const handleAddCase = async () => {
        dispatch(isCaseSaved(false));

        const caseLimit = remainingDemand + rollOverCredits;
        if (caseLimit <= 0) {
            const result = await confirm({
                title: "Subscription Limit Reached",
                html: caseLimitReachedHtml,
            });

            if (!result.isConfirmed) return;
        }

        await createCaseAndNavigate();
    };

    return (
            <XButton loadingText="Loading" buttonText={<><i className="fa-solid fa-plus me-2"></i> Add Case </>} onClick={handleAddCase} loading={isLoading} className="btn btn-theme ms-2 add-case-btn" style={{ height: "50px", width: "120px" }}/>
    );
};

export default AddCaseButton;
